import { authHeaders } from './api';

const { VITE_DJANGO_URL } = import.meta.env;
const apiUrl = VITE_DJANGO_URL;

export const fetchData = async (fetch_type, filter = '') => {
  try {
    const headers = authHeaders();
    let url = apiUrl + '/rest_1/' + fetch_type;
    if (filter != '') {
      url = url + '/' + filter;
    }
    const resp = await fetch(url, {
      method: 'GET',
      headers,
    });
    if (resp.ok) {
      const json = await resp.json();
      return json;
    }
  } catch (error) {
    return [];
  }
};

export const fetchPage = async (fetch_type, filter = '') => {
  try {
    const headers = authHeaders();
    let url = apiUrl + '/rest_1/' + fetch_type;
    if (filter != '') {
      url = url + '/' + filter;
    }
    const resp = await fetch(url, {
      method: 'GET',
      headers,
    });
    if (resp.ok) {
      const json = await resp.json();
      return json.data;
    }
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const fetchCountries = async () => {
  const headers = authHeaders();
  const url = apiUrl + '/v2/countries';
  const resp = await fetch(url, {
    method: 'get',
    headers,
  });
  const json = await resp.json();
  return json;
};
